// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"e821bb18","239":"1fb6c509","339":"3ce7c30d","396":"7f498436","455":"ba1492cc","457":"5831d3dc","639":"f6d385d4","640":"e784c740","851":"2fe9750f","977":"1ead4e4f"}[chunkId] + ".chunk.js";
};